module.exports = __webpack_public_path__ + "static/media/02.dc30e112.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/02.jpg
// module id = 461
// module chunks = 0